/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {

  // Iterate over each anchor element within the list items of the main navigation
  document.querySelectorAll('.Header__MainNav li > a').forEach(function(anchor) {
    var loc = location.pathname;
    if (loc.replace(/\/[^\/]*\.html$/, '').startsWith(anchor.getAttribute('href').replace(/\.html$/, ''))) {
      var liElement = anchor.closest("li");
      if (liElement) {
        liElement.classList.add('is-expanded');
      }
    }
  });

  // Add event listener to the parent container
  var pnc = document.querySelector('.prod_nav_container');
  if(pnc){
    document.querySelector('.prod_nav_container').addEventListener('click', function(event) {
      if (event.target.classList.contains('prod-nav-item')) {
        var activeItem = event.currentTarget.querySelector('.active');
        if (activeItem) {
          activeItem.classList.remove('active');
        }
        event.target.classList.add('active');
      }
    });
  }
});


function adapterProcedure(input) {

    var rtn = WL.Server.invokeHttp(input);
    rtn = JSON.parse(unescape(encodeURIComponent(JSON.stringify(rtn))));
    return rtn;
}